export default __webpack_public_path__ + "ff32e10a1ce37e3fb53543226905a20b.png";